<template>
  <div class="relative">
    <div class="w-full h-full absolute bg-white rounded-content-md"></div>
    <div class="relative w-full h-full p-6 py-8">
      <div class="whitespace-nowrap">{{ title }}</div>
      <div class="w-full h-full flex justify-between gap-2 items-center">
        <div>
          <div class="py-1"></div>
          <div class="whitespace-nowrap">
            <span class="title-color text-3xl font-bold">{{ totalValue }} </span
            >&nbsp;
            <span class="text-md">
              {{ unit }}
            </span>
          </div>
          <div class="py-1"></div>
          <div class="text-sm whitespace-nowrap pointer-events-none">
            <DropdownComponent
              :selects="Object.values(periods)"
              maxHeight="270px"
              displayKey="name"
              toRight
              :onSelect="
                period => {
                  selectPeriod(period)
                }
              "
            >
              {{ periods[selectedPeriod].name }}
            </DropdownComponent>
          </div>
        </div>
        <div class="w-1/2 relative flex justify-center">
          <div
            class="pointer-events-none absolute bottom-full bg-white px-4 py-2 border rounded-xl shadow-b-2xl z-[2] whitespace-nowrap text-center duration-300"
            :class="{
              'translate-y-1/2 opacity-0 ': !statDetail.isVisible,
              'translate-y-0 opacity-100': statDetail.isVisible,
            }"
          >
            <div>{{ statDetail.title }}</div>
            <div class="font-bold text-lg title-color">
              {{ statDetail.value }}
            </div>
          </div>
          <div class="w-full">
            <svg
              class="w-full fill-transparent -scale-y-100"
              viewBox="-10 -10 140 80"
            >
              <path
                class="stroke-primary stroke-2 duration-300"
                :d="
                  statsOfPeriodValues
                    .map(
                      (val, i) =>
                        `${i == 0 ? 'M' : 'L'}${(i * 120) / statsOfPeriodValues.length},${(val * 60) / maxPeriodValue}`,
                    )
                    .join(' ')
                "
              />
              <circle
                class="fill-primary stroke-transparent stroke-[20] duration-300"
                v-for="(val, i) in statsOfPeriodValues"
                :cx="(i * 120) / statsOfPeriodValues.length"
                :cy="(val * 60) / maxPeriodValue"
                r="1"
                onmouseover="evt.target.setAttribute('r', '10');"
                onmouseout="evt.target.setAttribute('r', '1');"
                @mouseover="showStatDetail(val, i)"
                @mouseout="hideStatDetail()"
                :key="i"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'

const sampleStats = {
  month: [
    0, 30, 10, 10, 70, 40, 40, 10, 10, 40, 10, 70, 40, 40, 10, 10, 40, 10, 10,
  ],
  year: [0, 30, 10, 10, 70, 40, 40, 10, 10, 40, 10, 10],
  week: [0, 30, 10, 10, 70, 40, 40],
  previousWeek: [10, 70, 40, 40, 0, 30, 10],
}

export default defineComponent({
  name: 'PlatformStats',
  components: { DropdownComponent },
  props: {
    title: {
      type: String,
      default: '',
    },
    unit: {
      type: String,
      default: '',
    },
    stats: {
      type: String,
      default: () => {
        return sampleStats
      },
    },
  },
  data() {
    return {
      periods: {
        year: { name: 'Année', id: 'year' },
        month: { name: '30 Jours', id: 'month' },
        week: { name: 'Semaine passée', id: 'week' },
        previousWeek: { name: 'Cette Semaine', id: 'previousWeek' },
      },
      selectedPeriod: 'month',
      statDetail: {
        isVisible: false,
        title: 'Details',
        value: 'val',
      },
    }
  },
  mounted() {},
  methods: {
    selectPeriod(period) {
      this.selectedPeriod = period.id
    },
    showStatDetail(value, position) {
      const statData = this.statsOfPeriod[position]
      const days = [
        'Lundi',
        'Mardi',
        'Mercredi',
        'Jeudi',
        'Vendredi',
        'Samedi',
        'Dimanche',
      ]
      const dates = new Array(this.statsOfPeriodValues.length)
        .fill('')
        .map((el, i) => `Date: ${i}`)
      const month = [
        'Janvier',
        'Février',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Aout',
        'Septembre',
        'Octobre',
        'Novembre',
        'Décembre',
      ]
      const titles = {
        week: days,
        previousWeek: days,
        month: dates,
        year: month,
      }
      this.statDetail.title = statData.title || ''
      this.statDetail.value = statData.detail || statData.value
      this.statDetail.isVisible = true
    },
    hideStatDetail() {
      this.statDetail.isVisible = false
    },
  },
  computed: {
    statsOfPeriod() {
      return this.stats[this.selectedPeriod]
      // return [0, 30, 10, 10, 70, 40, 40 /* , 10, 10, 40, 10, 10 */]
    },
    statsOfPeriodValues() {
      return this.statsOfPeriod.map(stat => stat.value || 0)
      // return [0, 30, 10, 10, 70, 40, 40 /* , 10, 10, 40, 10, 10 */]
    },
    maxPeriodValue() {
      return Math.max(...this.statsOfPeriodValues)
    },
    totalValue() {
      let total = 0
      this.statsOfPeriodValues.forEach(val => (total += val))
      return total
    },
  },
})
</script>
